export default "__VITE_ASSET__2d5e69bf__"